import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { catchError, map, of, switchMap } from 'rxjs';
import { UserSyncService } from '../resolvers/user-data.resolver';
import { TermsService } from '../services/terms.service';

export const termsAcceptanceGuard: CanActivateFn = () => {
  const termsService = inject(TermsService);
  const router = inject(Router);

  // Wait for sync-access (shared, called once) before checking Terms.
  return inject(UserSyncService).load().pipe(
    switchMap(() => termsService.getAcceptanceStatus()),
    map((status) => {
      if (status.accepted) {
        return true;
      }
      return router.createUrlTree(['/terms']);
    }),
    catchError(() => of(router.createUrlTree(['/terms'])))
  );
};
